import axiosInstance from "../../api/axiosConfig";

export const getBanners = () => {
  return axiosInstance.get("/home/banners");
};
